import React from 'react';
import { Banner, Flashy, Gutter, ParagraphHeader } from '@axiom/ui';

export type PreferencesBannerProps = {
  name?: string;
};

export const PreferencesBanner = ({
  name = 'PREFERENCES_BANNER',
}: PreferencesBannerProps = {}) => {
  return (
    <Gutter bottom="10px" name={name}>
      <Banner type="error" impact="high">
        <ParagraphHeader as="span">
          <Flashy bold>It's time to review your preferences.</Flashy>
        </ParagraphHeader>{' '}
        Take a look at the settings and make any necessary changes.
      </Banner>
    </Gutter>
  );
};
